export const SITE_NAME = '侍鈴々原作';